import { render, staticRenderFns } from "./initialPreferences.vue?vue&type=template&id=1c716651"
import script from "./initialPreferences.ts?vue&type=script&lang=js&external"
export * from "./initialPreferences.ts?vue&type=script&lang=js&external"
import style0 from "./initialPreferences.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports